<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
  v-card.neutral200
    v-card-text.neutral700--text.pa-8(outlined)
      v-row(justify="center")
        v-col(cols="9")
          div.d-flex.align-center.mb-6
            v-btn.mr-2(icon color="neutral700" @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-arrow-left
            .text-2xl.font-semibold {{ blastData.method === 'sms' ? 'SMS' : blastData.method === 'email' ? 'E-mail' : 'WhatsApp' }} {{ blastData.type === 'thank_you' ? 'thank you message' : '' }} deliverance
          v-alert.round-xl(v-if="isPaused" color="yellow500" text outlined)
            div.d-flex.align-center
              v-icon(color="yellow600" size="28") $yzi-alert-circle
              div.text-sm.font-semibold.neutral700--text.mx-3 Deliverance paused: Insufficient credit
              v-spacer
              y-button(label="Resolve" outlined size="sm" @click="openResolveDialog = true")
          v-form(ref="form")
            v-card.rounded-lg.content-box(outlined)
              div.pa-6
                div.d-flex.align-center
                  template(v-if="blastData.type === 'offer'")
                    div.text-md.neutral700--text(v-if="blastData.send_cue === 'offer_activated'") Blast immediately after offer created
                    div.text-md.neutral700--text(v-if="blastData.send_cue === 'scheduled'") Blast later on
                      span.font-medium.ml-1 {{ getScheduleText(blastData.schedules) }}
                  template(v-else)
                    div.text-md.neutral700--text {{ getSendToText(blastData) }}
                      span.font-medium.ml-1(v-if="blastData.send_to !== 'all'") {{ getSendCueText(blastData) }}
                  v-spacer
                  v-menu(offset-y left rounded="lg")
                    template(#activator="{ on }")
                      div(v-on="on")
                        y-button(label="Action" size="sm" prepend-icon="$yzi-chevron-down" button-class="pr-4 pl-2" outlined)
                    v-list.py-0
                      //- v-list-item(@click="editDeliverance")
                        v-list-item-title.text-sm.neutral700--text Edit
                      //- v-divider.neutral300(style="height: 95px;")
                      v-list-item(@click="openTestDialog(blastData.method)")
                        v-list-item-title.text-sm.neutral700--text Send test message
                      //- v-divider.neutral300
                      //- v-list-item(@click="")
                      //-   v-list-item-title.text-sm.neutral700--text Preview
                      //- template(v-if="offer.status === 'scheduled'")
                        v-divider
                        v-list-item(@click="openDeleteDialog = true")
                          v-list-item-title.text-sm.danger500--text Delete

                v-card.rounded-lg.content-box.pa-6.mt-6(outlined)
                  v-row
                    v-col(cols="3")
                      div.text-xs.neutral700--text Total successful sent {{ blastData.method === 'sms' ? 'SMS' : blastData.method === 'email' ? 'e-mail' : 'WhatsApp' }}
                      div.d-flex.align-center.mt-4
                        v-icon.mr-2(size="24" color="success500") $yzi-check-circle-solid
                        div.text-g5 {{ blastData.total_success | displayNumber }}
                    v-divider.neutral300(vertical)
                    v-col(cols="3")
                      div.text-xs.neutral700--text Total unsuccessful sent {{ blastData.method === 'sms' ? 'SMS' : blastData.method === 'email' ? 'e-mail' : 'WhatsApp' }}
                      div.d-flex.align-center.mt-4
                        v-icon.mr-2(size="24" color="danger500") $yzi-x-circle
                        div.text-g5 {{ blastData.total_failed | displayNumber }}
                    v-col(cols="6")
                      div.d-flex.align-center
                        div.text-sm.font-medium.neutral500--text Total {{ blastData.method === 'sms' ? 'SMS' : blastData.method === 'email' ? 'e-mail' : 'WhatsApp' }} blasted
                        v-spacer
                        div.text-sm.font-medium.neutral700--text {{ (blastData.total_success + blastData.total_failed) | displayNumber }}
                      v-divider.neutral300.my-1
                      div.d-flex.align-center
                        div.text-sm.font-medium.neutral500--text Total successful deliveries
                        v-spacer
                        div.text-sm.font-medium.neutral700--text {{ blastData.total_success | displayNumber }} ({{ Math.floor(blastData.total_success*100/(blastData.total_success + blastData.total_failed)) || 0 }}%)
                      v-divider.neutral300.my-1
                      div.d-flex.align-center
                        div.text-sm.font-medium.neutral500--text Total unsuccessful deliveries
                        v-spacer
                        div.text-sm.font-medium.neutral700--text  {{ blastData.total_failed | displayNumber }} ({{ Math.floor(blastData.total_failed*100/(blastData.total_success + blastData.total_failed)) || 0 }}%)
                      v-divider.neutral300.my-1
                      div.d-flex
                        div.text-sm.font-medium.neutral500--text Blast dates
                        v-spacer
                        div
                          div.text-sm.font-medium.neutral700--text(v-for="(schedule, idx) in blastData.schedules" :key="`sch-${idx}`") {{ schedule.scheduled_for | convertServerDate2 }}
              v-divider.neutral300
              div.pa-6
                div.text-md.font-semibold.neutral700--text Audience
                audience-list(:blast-data="blastData")
           
    v-divider.neutral300
    v-card-actions.py-4.px-8.white
      v-spacer
      y-button(label="Done" text-color="neutral100" color="neutral700" size="sm" dark :loading="isLoading" @click="closeDialog")
    
  .dialogs
    resolve-paused-dialog(v-if="openResolveDialog" :open.sync="openResolveDialog" :schedules.sync="pausedSchedules" :blast="blastData" @updated="updateResolve")
    send-test-sms-dialog(v-if="openTestSmsDialog" :open.sync="openTestSmsDialog" :blast-data="blastData")
    send-test-email-dialog(v-if="openTestEmailDialog" :open.sync="openTestEmailDialog" :blast-data="blastData")
    send-test-whatsapp-dialog(v-if="openTestWhatsappDialog" :open.sync="openTestWhatsappDialog" :blast-data="blastData")
    delete-confirmation-dialog(v-if="openDeleteDialog" :open.sync="openDeleteDialog" :loading="isLoading" @cancel="closed" @delete="confirmDelete")
      .text-lg.font-medium Are you sure you want to delete this deliverance?
      .text-md.mt-4 All of the deliverance settings will be deleted and cannot be recovered. The deliverance also will not be commenced upon offer’s campaign completion. 
      .text-md.mt-4 Click “Delete” to confirm

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AudienceList from '@/components/clinic/marketing/AudienceList.vue'
import ResolvePausedDialog from '@/components/clinic/marketing/dialogs/ResolvePausedDialog.vue'
import SendTestSmsDialog from '@/components/clinic/marketing/dialogs/SendTestSmsDialog.vue'
import SendTestEmailDialog from '@/components/clinic/marketing/dialogs/SendTestEmailDialog.vue'
import SendTestWhatsappDialog from '@/components/clinic/marketing/dialogs/SendTestWhatsappDialog.vue'
import DeleteConfirmationDialog from '@/components/clinic/dialogs/DeleteConfirmationDialog.vue'


export default {
  components: { AudienceList, ResolvePausedDialog, SendTestSmsDialog, SendTestEmailDialog, SendTestWhatsappDialog, DeleteConfirmationDialog },
  props: {
    open: {
      type: Boolean,
    },
    blastData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      isPaused: false,
      openResolveDialog: false,
      openTestSmsDialog: false,
      openTestWhatsappDialog: false,
      openTestEmailDialog: false,
      openDeleteDialog: false,
      pausedSchedules: [],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  mounted () {
    this.fetchScheduleStatus()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchScheduleStatus () {
      this.isPaused = false
      this.$axios.get(`/marketing/${this.company.slug}/blasts/${this.blastData.id}/schedules`, { params: { status: 'paused' } })
        .then(resp => {
          if (resp.data && resp.data.results && resp.data.results.length) {
            this.isPaused = true
            this.pausedSchedules = resp.data.results
          }
        })
        .catch(() => {})
    },
    editDeliverance () {
      this.$emit('edited', `${this.blastData.method}-${this.blastData.type}`)
      this.showDialog = false
    },
    confirmDelete () {
      this.isLoading = true
      this.$axios.delete(`/marketing/${this.company.slug}/blasts/${this.blastData.id}`)
        .then(() => {
          this.$emit('deleted')
          this.closeDialog()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateResolve () {
      this.$emit('deleted')
      this.fetchScheduleStatus()
    },
    closeDialog () {
      this.$emit('closed')
      this.showDialog = false
    },
    getSendToText (data) {
      let text = null
      if (data.send_to === 'redeemed_recipient') {
        text = 'Send to customer that redeemed the offer'
      } else if (data.send_to === 'all') {
        text = 'Send to everyone'
      }
      return text
    },
    getSendCueText (data) {
      let text = null
      if (data.send_cue === 'offer_redeemed') {
        text = `${data.auto_send_delay_time_value} min after redemption`
      } else if (data.send_cue === 'scheduled') {
        text = `on ${this.$options.filters.convertServerDate(data.schedules[0].scheduled_for)}`
      } else if (data.send_cue === 'offer_ended') {
        text = 'right after the campaign ended'
      }
      return text
    },
    getScheduleText (schedules) {
      let text = null
      if (schedules.length) {
        let datetimes = schedules.map(m => m.scheduled_for)
        if (datetimes.length > 2) {
          text = `${this.$options.filters.convertServerDate(datetimes[0])}, ${this.$options.filters.convertServerDate(datetimes[1])} and ${datetimes.length - 2} more`
        } else if (datetimes.length > 1) {
          text = `${this.$options.filters.convertServerDate(datetimes[0])} and ${this.$options.filters.convertServerDate(datetimes[1])}`
        } else {
          text = `${this.$options.filters.convertServerDate(datetimes[0])}`
        }
      }
      return text
    },
    openTestDialog(method) {
      if (method === 'sms') {
        this.openTestSmsDialog = true
      } else if (method === 'email') {
        this.openTestEmailDialog = true
      } else if (method === 'whatsapp') {
        this.openTestWhatsappDialog = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table__wrapper table tbody tr:hover{
    cursor: pointer;
    background: var(--v-neutral200) !important; 
  }
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>